/** Strings owned by `src/manage/companies/` — the Companies section under
 * `/manage` (§ Beheer): the list, the detail page and its internals, and the
 * write forms (new/edit/delete/settings/domains). */
export const companies = {
  list: {
    title: 'Companies',
    newCompany: 'New company',
    empty: 'No companies are visible to you.',
    name: 'Name',
    created: 'Created',
    rowsLabel: 'the companies',
    healthTitle: 'Organisation health',
    healthCompanies: 'Companies',
    healthEditions: 'Editions',
    healthPilots: 'Pilots',
    healthPilotsLabel: 'the pilot summary',
    healthActivePilotCount: '{{count}} companies with an active pilot',
  },
  detail: {
    thisCompany: 'company',
    rename: 'Rename',
    companyAdmins: 'Company admins',
    delete: 'Delete',
    departmentsTitle: 'Departments',
    newDepartment: 'New department',
    departmentsEmpty: 'No departments yet.',
    departmentsLabel: 'the departments',
    name: 'Name',
    statistics: 'Statistics',
    collectiveConsent: 'Collective consent',
    inForce: 'in force',
    settingsTitle: 'Settings',
    settingsLabel: 'the settings',
    change: 'Change',
    minGroupSizeLabel: 'Minimum group size for aggregates:',
    systemDefault: 'system default',
    companyOverride: 'company override',
    domainsTitle: 'E-mail domains',
    domainsLabel: 'the domains',
    manage: 'Manage',
    domainsEmpty: 'No domains registered.',
    membersTitle: 'Members',
    membersLabel: 'the members',
    addPerson: 'Add person',
    membersEmpty: 'No members.',
    email: 'E-mail',
    login: 'Login',
    source: 'Source',
    actions: 'Actions',
    yes: 'yes',
    no: 'no',
  },
  form: {
    newTitle: 'New company',
    name: 'Name',
    cancel: 'Cancel',
    create: 'Create company',
    editTitle: 'Rename company',
    save: 'Save',
    deleteTitle: 'Delete company',
    deleteLead:
      'Deleting {{name}} also ends its domains and membership rows. This cannot be undone. Type the company name to confirm.',
    companyNameLabel: 'Company name',
    deletePermanently: 'Delete permanently',
    settingsTitle: 'Aggregate threshold',
    settingsLead:
      'The minimum group size below which aggregates are not shown. Leave empty to return to the system default. The API enforces a hard floor.',
    minGroupSize: 'Minimum group size',
    domainsTitle: 'E-mail domains',
    domainsLead:
      'A verified address on one of these domains enrolls its holder into this company at sign-in. Existing memberships stay when a domain is removed.',
    remove: 'Remove',
    addDomain: 'Add domain',
    add: 'Add',
    backToCompany: 'Back to the company',
  },
  /** "Organisatiegezondheid" card (PLAN-FASE2.md WP-07): edition + member
   * count (existing data) plus pilot status from WP-04's `GET /pilots`. */
  health: {
    title: 'Organisation health',
    edition: 'Edition',
    editionFit: 'Fit',
    editionSoccer: 'Soccer',
    members: 'Members',
    pilotsTitle: 'Pilots',
    pilotsLabel: 'the pilot status',
    noPilots: 'No pilots yet.',
    activeCount: '{{count}} active',
    scaledCount: '{{count}} scaled',
    totalCount: '{{count}} total',
    viewAllPilots: 'View all pilots',
  },
} as const;
